import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/back2.png';
const _withScopeId = n => (_pushScopeId("data-v-01875d99"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page-box",
  style: {
    "position": "relative"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = [_hoisted_2];
import { ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { useCommon } from '@/common/hooks/useCommon';
import { useLayoutStore, useStaticDictStore } from '@/store';
import { useDownload } from '@/common/hooks/useDownload';
import { useDropdown } from '@/common/hooks/useDropdown';
import { useUpload } from '@/common/hooks/useUpload';
import { useUploadWidget } from '@/common/hooks/useUploadWidget';
import { DictionaryController } from '@/api/system';
import { WkcNoticeController } from '@/api/generated';
import LoginMessageController from '@/api/generated/loginMessageController';
import { ref } from 'vue';

import { reactive, getCurrentInstance, computed, onMounted } from 'vue';
// 表单数据
const __default__ = {
  name: 'noticeDialog'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    id: {
      default: undefined
    },
    subPage: {
      type: [Number, String, Boolean],
      default: 0
    },
    saveOnSubmit: {
      type: Boolean,
      default: true
    },
    rowData: {
      default: undefined
    }
  },
  setup(__props) {
    const isRichEditorDisabled = ref(true);
    const router = useRouter();
    const route = useRoute();
    const layoutStore = useLayoutStore();
    const {
      downloadFile
    } = useDownload();
    const {
      getUploadHeaders,
      getUploadActionUrl,
      fileListToJson,
      parseUploadData,
      getPictureList
    } = useUpload();
    const {
      Delete,
      Search,
      Edit,
      Plus,
      Refresh,
      Picture,
      Dialog,
      mainContextHeight,
      clientHeight,
      checkPermCodeExist,
      parseParams,
      parseArrayParams,
      formatDateByStatsType,
      getDateRangeFilter
    } = useCommon();
    // 静态字典
    const {
      staticDict: StaticDict
    } = useStaticDictStore();
    const props = __props;
    const noticeDialogRef = ref();
    // 表单数据定义
    const formData = reactive({
      WkcNotice: {
        // 公告ID
        id: undefined,
        // 公告标题
        title: undefined,
        // 公告内容
        content: undefined,
        // 公告类型
        type: undefined,
        // 通知用户
        publisher: undefined,
        // 开始时间
        startTime: undefined,
        // 结束时间
        endTime: undefined,
        // 是否置顶，0: 否，1: 是
        isTop: undefined,
        // 公告状态，0: 已删除，1: 正常
        status: undefined,
        // 创建者Id
        createUserId: undefined,
        // 创建时间
        createTime: undefined,
        // 更新者Id
        updateUserId: undefined,
        // 更新时间
        updateTime: undefined,
        // 部门
        department: undefined,
        // 文件上传
        fileType: undefined,
        // 删除标记(1:正常 -1:已删除)
        deletedFlag: undefined,
        // 通知内容
        noticeScope: undefined,
        // 所属部门
        dept: undefined
      }
    });
    // 表单验证规则
    const rules = reactive({
      'WkcNotice.startTime': [],
      'WkcNotice.fileType': [],
      'WkcNotice.publisher': [],
      'WkcNotice.noticeScope': [{
        required: true,
        message: '请输入通知内容',
        trigger: 'blur'
      }],
      'WkcNotice.title': [{
        required: true,
        message: '请输入公告标题',
        trigger: 'blur'
      }],
      'WkcNotice.type': []
    });
    const instance = getCurrentInstance();
    const onCancel = () => {
      router.go(-1);
      layoutStore.removeCachePage(route.fullPath);
      route.meta.refreshParentCachedPage = true;
    };
    const isEdit = computed(() => {
      return props.saveOnSubmit ? props.id != null : props.rowData != null;
    });
    // 初始化页面数据
    const loadWkcNoticeData = () => {
      return new Promise((resolve, reject) => {
        if (!isEdit.value) {
          resolve();
          return;
        }
        if (!props.saveOnSubmit && props.rowData != null) {
          formData.WkcNotice = JSON.parse(JSON.stringify(props.rowData));
          resolve();
          return;
        }
        let params = {
          id: props.id
        };
        WkcNoticeController.view(params).then(res => {
          formData.WkcNotice = {
            ...res.data
          };
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    };
    /**
     * 公告类型下拉数据获取函数
     */
    const loadTypeDropdownList = () => {
      return new Promise((resolve, reject) => {
        DictionaryController.dictGlobalDict({
          dictCode: 'NoticeType',
          itemIdType: 'Integer'
        }).then(res => {
          resolve({
            dataList: res.getList()
          });
        }).catch(e => {
          reject(e);
        });
      });
    };
    // 公告类型配置参数
    const typeOptions = {
      loadData: loadTypeDropdownList,
      isTree: false
    };
    // 公告类型下拉组件
    const typeWidget = useDropdown(typeOptions);
    const {
      dropdownList: typeWidgetDropdownList
    } = typeWidget;
    /**
     * 发布用户下拉数据获取函数
     */
    const loadPublisherDropdownList = () => {
      return new Promise((resolve, reject) => {
        const params = {};
        DictionaryController.dictSysUser(params).then(res => {
          resolve({
            dataList: res.getList()
          });
        }).catch(e => {
          reject(e);
        });
      });
    };
    // 发布用户配置参数
    const publisherOptions = {
      loadData: loadPublisherDropdownList,
      isTree: false
    };
    // 发布用户下拉组件
    const publisherWidget = useDropdown(publisherOptions);
    const {
      dropdownList: publisherWidgetDropdownList
    } = publisherWidget;
    /**
     * 文件上传上传文件改变
     */
    const onFileTypeChange = val => {
      formData.WkcNotice.fileType = fileListToJson(val);
    };
    // 文件上传上传文件组件
    const fileTypeWidget = useUploadWidget(30);
    const {
      fileList: fileTypeWidgetFileList,
      maxCount: fileTypeWidgetMaxCount
    } = fileTypeWidget;
    const noticeScope = ref();
    const onUploadError = () => {
      ElMessage.error('文件上传失败');
    };
    const onUploadLimit = () => {
      ElMessage.error('已经超出最大上传个数限制');
    };
    const refreshNoticeDialog = () => {
      // 刷新段落
    };
    /**
     * 重置过滤值
     */
    const resetNoticeDialog = () => {
      refreshNoticeDialog();
    };
    /**
     * 重置所有过滤值
     */
    const resetFilter = () => {
      resetNoticeDialog();
    };
    const formInit = () => {
      loadWkcNoticeData().then(res => {
        typeWidget.onVisibleChange(true).catch(e => {
          console.error(e);
        });
        publisherWidget.onVisibleChange(true).catch(e => {
          console.error(e);
        });
        let fileTypeDownloadParams = {
          id: formData.WkcNotice.id,
          fieldName: 'fileType',
          asImage: false
        };
        fileTypeWidgetFileList.value = parseUploadData(formData.WkcNotice.fileType, fileTypeDownloadParams);
        if (isEdit.value) refreshNoticeDialog();
      }).catch(e => {
        // TODO: 异常处理
        console.error(e);
      });
    };
    const fetchNotificationDetail = async () => {
      let params = {};
      LoginMessageController.sendMessage(params).then(res => {
        console.log("res2222222");
        if (res.success == "yes") {
          formData.WkcNotice = res.data[0];
          formData.WkcNotice.noticeScope = res.data[0].notice_scope;
          formData.WkcNotice.startTime = res.data[0].create_time;
          formData.WkcNotice.fileType = res.data[0].file_type;
          let fileTypeDownloadParams = {
            id: formData.WkcNotice.id,
            fieldName: 'fileType',
            asImage: false
          };
          fileTypeWidgetFileList.value = parseUploadData(formData.WkcNotice.fileType, fileTypeDownloadParams);
          if (isEdit.value) refreshNoticeDialog();
          params = {
            id: formData.WkcNotice.message_id
          };
          // 抄送消息
          WkcNoticeController.viewCopyBusinessData(params).then(res => {});
          ElMessage.success('通知公告已阅读！');
        }
      }).catch(e => {
        ElMessage.error('暂无新的通知！');
        return;
      });
    };
    onMounted(() => {
      formInit();
      fetchNotificationDetail();
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_custom_upload = _resolveComponent("custom-upload");
      const _component_upload_file_list = _resolveComponent("upload-file-list");
      const _component_rich_editor = _resolveComponent("rich-editor");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
        class: "custom-scroll content-box"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "noticeDialogRef",
          ref: noticeDialogRef,
          model: _unref(formData),
          size: _unref(layoutStore).defaultFormItemSize,
          rules: _unref(rules),
          "label-width": "120px",
          "label-position": "right",
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 16,
            style: {
              "background": "white",
              "padding": "16px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, {
                gutter: 16
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 16
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, {
                gutter: 16
              }, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "公告标题",
                    prop: "WkcNotice.title"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      class: "input-item",
                      modelValue: _unref(formData).WkcNotice.title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).WkcNotice.title = $event),
                      type: "text",
                      placeholder: "",
                      clearable: true,
                      "show-word-limit": false,
                      maxlength: "",
                      disabled: true
                    }, null, 8, ["modelValue"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "公告类型",
                    prop: "WkcNotice.type"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_select, {
                      class: "input-item",
                      modelValue: _unref(formData).WkcNotice.type,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).WkcNotice.type = $event),
                      placeholder: "",
                      clearable: true,
                      filterable: true,
                      disabled: true,
                      onVisibleChange: _unref(typeWidget).onVisibleChange
                    }, {
                      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(typeWidgetDropdownList), item => {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]);
                      }), 128))]),
                      _: 1
                    }, 8, ["modelValue", "onVisibleChange"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "发布用户",
                    prop: "WkcNotice.publisher"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_select, {
                      class: "input-item",
                      modelValue: _unref(formData).WkcNotice.publisher,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formData).WkcNotice.publisher = $event),
                      placeholder: "",
                      clearable: true,
                      filterable: true,
                      disabled: true,
                      onVisibleChange: _unref(publisherWidget).onVisibleChange
                    }, {
                      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(publisherWidgetDropdownList), item => {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]);
                      }), 128))]),
                      _: 1
                    }, 8, ["modelValue", "onVisibleChange"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "发布时间",
                    prop: "WkcNotice.startTime"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                      class: "input-item",
                      modelValue: _unref(formData).WkcNotice.startTime,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(formData).WkcNotice.startTime = $event),
                      type: "datetime",
                      placeholder: "",
                      clearable: true,
                      format: "YYYY-MM-DD HH:mm:ss",
                      "value-format": "YYYY-MM-DD HH:mm:ss",
                      disabled: true
                    }, null, 8, ["modelValue"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "文件上传",
                    prop: "WkcNotice.fileType"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_custom_upload, {
                      modelValue: _unref(fileTypeWidgetFileList),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(fileTypeWidgetFileList) ? fileTypeWidgetFileList.value = $event : null),
                      name: "uploadFile",
                      size: _unref(layoutStore).defaultFormItemSize,
                      type: "dropdown",
                      headers: _unref(getUploadHeaders),
                      action: _unref(getUploadActionUrl)('/admin/app/wkcNotice/upload'),
                      data: {
                        fieldName: 'fileType',
                        asImage: false
                      },
                      limit: _unref(fileTypeWidgetMaxCount),
                      onChange: onFileTypeChange,
                      disabled: true
                    }, null, 8, ["modelValue", "size", "headers", "action", "limit"]), _createVNode(_component_upload_file_list, {
                      "file-list": _unref(fileTypeWidgetFileList),
                      type: "card",
                      direction: "horizontal",
                      readonly: true
                    }, null, 8, ["file-list"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  span: 24
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "通知内容",
                    class: "rich-input",
                    prop: "WkcNotice.noticeScope"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_rich_editor, {
                      ref_key: "noticeScope",
                      ref: noticeScope,
                      class: _normalizeClass(["input-item", {
                        'rich-editor-disabled': isRichEditorDisabled.value
                      }]),
                      modelValue: _unref(formData).WkcNotice.noticeScope,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(formData).WkcNotice.noticeScope = $event),
                      disabled: _ctx.rich - _ctx.editor
                    }, null, 8, ["modelValue", "disabled", "class"])]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "size", "rules"])]),
        _: 1
      }), _ctx.subPage ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: "page-close-box",
        onClick: _cache[7] || (_cache[7] = $event => onCancel())
      }, _hoisted_3)) : _createCommentVNode("", true)]);
    };
  }
});